import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Button } from 'app/components/ui/Button'
import { Card } from 'app/components/ui/Card'
import { Form } from 'app/components/ui/Form'
import { Text } from 'app/components/ui/Text'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import { useLogin } from 'app/queries/login'
import { routes } from 'app/routing/routes'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import revealPasswordIcon from 'static/icons/reveal_password.svg'
import styled, { useTheme } from 'styled-components'

import {
  adaptFormDataToAPI,
  loginDefaultValues,
  LoginFormData,
  loginValidationSchema,
} from './form'

export const LoginForm = (): JSX.Element => {
  const { login } = useAuth()
  const theme = useTheme()

  const [revealPassword, setRevealPassword] = useState(false)

  const { mutate: executeLogin, isLoading, isError, error } = useLogin(login)

  const toggleRevealPassword = () => {
    setRevealPassword((prev) => !prev)
  }

  const onSubmit = (data: LoginFormData) =>
    executeLogin(adaptFormDataToAPI(data))

  return (
    <Form<LoginFormData>
      defaultValues={loginDefaultValues}
      validationSchema={loginValidationSchema}
      onSubmit={onSubmit}
    >
      <>
        <FormCard shadow padding='2rem'>
          <FormGroup>
            <SmartInput
              label='Email'
              type='email'
              name='email'
              bgColor={theme.color.neutri.grigioBg}
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='Password'
              type={revealPassword ? 'text' : 'password'}
              bgColor={theme.color.neutri.grigioBg}
              name='password'
              sideButton={
                <Button
                  type='button'
                  variant='grey'
                  onClick={() => toggleRevealPassword()}
                >
                  <img
                    src={revealPasswordIcon}
                    alt='reveal password'
                    width='20px'
                    height='20px'
                  />
                </Button>
              }
            />
          </FormGroup>
          <Text mb={0.5}>
            Non hai un account?{' '}
            <Link to={routes.signup.path}>Effettua la registrazione</Link>
          </Text>
          <LinkWrapper>
            <Link to={routes.forgotPassword.path}>
              Ho dimenticato la password
            </Link>
          </LinkWrapper>
          <LinkWrapper>
            <Link to={routes.resendConfirmUserEmail.path}>
              Non ho ricevuto la mail di conferma
            </Link>
          </LinkWrapper>
        </FormCard>
        <ButtonApiErrorWrapper isError={isError} error={error} alignCenter>
          <Button size='lg' type='submit' disabled={isLoading}>
            {isLoading ? 'Caricamento...' : 'ENTRA'}
          </Button>
        </ButtonApiErrorWrapper>
      </>
    </Form>
  )
}

const FormCard = styled(Card)`
  margin-bottom: 2rem;
`
const LinkWrapper = styled.div`
  margin-bottom: 0.5rem;
`
